import React from 'react';
import { Wrapper } from '../../../../../../../CommonComponents/Modal/styles';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableTitle,
  TableWrapper,
} from '../../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  title: string;
  children: React.ReactNode;
}

export const RealizedGainLossDetailsSkeleton = ({ title, children }: Props) => {
  return (
    <Wrapper>
      <TableWrapper mb="4">
        <TableTitle>
          <Text fontWeight={600} fontSize="h6">
            {title}
          </Text>
        </TableTitle>

        <TableHeader>
          <TableRow>
            <TableCell width="100%">&nbsp;</TableCell>
          </TableRow>
        </TableHeader>

        <TableBody>{children}</TableBody>
      </TableWrapper>
    </Wrapper>
  );
};
